<template>
  <q-dialog
    v-model="show"
    :maximized="maximized"
    @input="(val) => $emit('input', val)"
  >
    <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
      <q-header class="bg-primary">
        <q-toolbar>
          <q-toolbar-title>{{ label }}</q-toolbar-title>
          <q-btn v-close-popup flat round dense icon="close" />
        </q-toolbar>
      </q-header>
      <q-page-container style="max-height: 85vh" class="scroll">
        <jt-input
          ref="registration"
          v-model="registration"
          class="col-12 q-mb-md registration"
          name="descricao"
          :float-label="$gettext('REGISTRATION')"
          type="text"
        />
        <q-table
          flat
          bordered
          :rows="rows"
          :data="rows"
          :columns="columns"
          row-key="id"
          :pagination="initialPagination"
        />
      </q-page-container>
    </q-layout>
  </q-dialog>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtInput } from 'jtech-webcomps'

@Component({
  name: 'BillingOrderConcessionModal',
  components: { JtDataTable, JtInput },
  props: {
    label: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object,
    buttons: {
      required: false,
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      required: true,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    show: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Boolean,
      default: false
    },
    maximized: {
      type: Boolean,
      default: false
    }
  }
})
class BillingOrderConcessionModal extends Vue {
  registration = null
  serverPagination = {
    page: 1,
    descending: false,
    rowsNumber: 20,
    rowsPerPage: 15
  };

  initialPagination = {
    sortBy: 'desc',
    descending: false,
    page: 1,
    rowsPerPage: 25
  };

  get columns () {
    return this.fields.map((field) => ({
      ...field,
      sortable: true
    }))
  }

  get rows () {
    const filters = this.registration ? this.registration.split(',') : []
    return this.data.filter(field => filters.length === 0 || filters.includes(field.id + ''))
  }

  get computedProps () {
    return {
      ...this.$props,
      columns: this.fields
    }
  }

  filter () {
    this.registration
  }
}
export default BillingOrderConcessionModal
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.registration{
  margin: 0px 30px;
}

::v-deep .q-table th.sortable {
  height: 40px;
  text-transform: uppercase;
  font-weight: 500;
  background-color: #f1f1f1;
  color: #707070;
  position: sticky;
  top: 0;
  opacity: 1;
  z-index: 1;
  font-size: 1em;
}

</style>
